
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEarlyAdopter } from '@/contexts/EarlyAdopterContext';
import SEO from '@/components/SEO';

const GetVIP = () => {
  const { openModal, isModalOpen } = useEarlyAdopter();
  const navigate = useNavigate();

  console.log('🎯 GetVIP page rendering on path:', window.location.pathname);
  console.log('🎯 GetVIP modal state:', isModalOpen);

  useEffect(() => {
    console.log('🔧 GetVIP useEffect running - ensuring modal opens for direct route');
    
    // For dedicated routes, ensure modal opens (context will handle the logic)
    if (!isModalOpen) {
      console.log('🚀 GetVIP: Requesting modal open for dedicated route');
      const source = `Direct VIP Page - ${window.location.pathname}`;
      openModal(source);
      
      // If modal still doesn't open after a short delay, redirect to home
      setTimeout(() => {
        if (!isModalOpen) {
          console.log('🔄 Modal did not open, redirecting to home');
          navigate('/');
        }
      }, 1000);
    }
  }, []);

  // If modal is closed (user dismissed it), redirect to home
  useEffect(() => {
    if (!isModalOpen) {
      const timer = setTimeout(() => {
        console.log('🔄 Modal closed or failed to open, redirecting to home');
        navigate('/');
      }, 2000);
      
      return () => clearTimeout(timer);
    }
  }, [isModalOpen, navigate]);

  return (
    <>
      <SEO 
        title="Get VIP Early Access - SeniorThrive"
        description="Join our exclusive early access community and be the first to experience SeniorThrive's revolutionary platform for aging at home."
        keywords="VIP early access, SeniorThrive early access, exclusive preview, senior care platform"
      />
      
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Opening early access signup...</p>
        </div>
      </div>
    </>
  );
};

export default GetVIP;
